import React, { useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { OverlayPanel } from 'primereact/overlaypanel';

interface SearchFilterTogglerProps {
  setSearchFilter: React.Dispatch<React.SetStateAction<string>>;
}

interface searchFilterLabel {
  name: string;
  code: string;
}

const SearchFilterToggler: React.FC<SearchFilterTogglerProps> = ({
  setSearchFilter
}) => {
  const op = useRef<OverlayPanel>(null);
  const [selectedFilterLabel, setSelectedFilterLabel] = useState<searchFilterLabel | null>(null);

  const filtersLabel: searchFilterLabel[] = [
    { name: 'Дата регистрации наряда', code: 'creationDateBetween' },
    {
      name: 'Дата начала работы (план)',
      code: 'plannedStartDateBetween'
    },
    {
      name: 'Дата начала работы (факт)',
      code: 'actualStartDateBetween'
    },
    {
      name: 'Дата завершения работы (план)',
      code: 'plannedEndDateBetween'
    },
    {
      name: 'Дата завершения работы (факт)',
      code: 'actualEndDateBetween'
    }
  ];

  useEffect(() => {
    const savedFilter = localStorage.getItem('searchFilter');
    if (savedFilter) {
      const foundFilterLabel = filtersLabel.find((filterLabel) => filterLabel.code === savedFilter);
      if (foundFilterLabel) {
        setSelectedFilterLabel(foundFilterLabel);
        setSearchFilter(savedFilter);
      }
    }
  }, []);

  const handleFilterLabelChange = (e: { value: searchFilterLabel }) => {

    if (!e.value) {
      op.current?.hide();
      return; 
    }
    const selected = e.value;
    setSelectedFilterLabel(selected);
    setSearchFilter(selected.code);
    localStorage.setItem('searchFilter', selected.code);
    op.current?.hide();
  };

  return (
    <div style={{ position: 'relative' }}>
      <Button
        icon="pi pi-calendar-plus"
        tooltip="Управление фильтрами по датам"
        tooltipOptions={{ position: 'top' }}
        onClick={(e) => {
          op.current?.toggle(e);
        }}
        className="p-button-rounded"
        severity="secondary"
      />

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable
        pt={{
          content: {
            style: {
              padding: 0
            }
          }
        }}
      >
        <div className="flex flex-column gap-3">
          <ListBox
            value={selectedFilterLabel}
            onChange={handleFilterLabelChange}
            options={filtersLabel}
            optionLabel="name"
            className="w-full"
          />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default SearchFilterToggler;
